import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { get_url_params } from "../../utils/commonUtilities";
import { Card, Button, Col, Input, Row, Upload, DatePicker, notification, Spin } from "antd";
import { UploadOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import api from '../../utils/apiRoutes'
import Cookies from "js-cookie";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday"
import localeData from "dayjs/plugin/localeData"
import { get_v10_url } from "../../utils/commonUtilities";
import { connect } from "react-redux";
import { updateBooking, updateBookingLoading } from "../../actions/bookingActions";

import './index.scss'
import GlobalLoader from "../GlobalLoader";

dayjs.extend(weekday)
dayjs.extend(localeData)

const FinalBill = (props) => {

    const history = useHistory()
    const bookingId = get_url_params("id")
    const dateFormat = "DD-MMM-YYYY"

    const [isYes, setIsYes] = useState(false)
    const [data, setData] = useState({
        _id: '',
        dod: '',
        doa: '',
        package: '0',
        consultation: '0',
        roomRent: '0',
        otCharges: '0',
        surgeonFees: '0',
        medicineConsumables: '0',
        others: '0',
        totalBill: '0',
        discount: '0',
        finalBill: '0',
        finalBillStatus: '',
        dischargeDoc: '',
        enhancements: [],
        tdsDeductions: '0',
        totalRoomRent: 0,
        investigation: '0',
        anesthetist: '0',
        documetId: '',
    })
    const [calculate, setCalculate] = useState(false)
    const [bookingData, setBookingData] = useState(null)
    const [disableSave, setDisableSave] = useState(false)
    const [dischargeDoc, setDichargeDoc] = useState('')
    const [enhancementDoc, setEnhanceMentDoc] = useState('')
    const [check, setCheck] = useState(false)
    const [documents, setDocuments] = useState([])

    useEffect(() => {
        let arr = window.location.href.split('/')
        const yes = arr[arr.length-1].split('?')[0] === 'yes'
        setIsYes(yes)
    },[])

    const openNotificationWithIcon = (type, message, description) => {
        notification[type]({
          message: message,
          description:
            description,
        });
    };

    useEffect(() => {
        if(!bookingId || bookingId.length===0) {
            history.push('/dashboard')
        }
        const headers = { 'headers' : { 'Authorization': `Bearer ${Cookies.get('token_medical_auth')}` }}
        const data = {
            booking_id: bookingId
        }
        api.booking.getBookingById(data, headers)
        .then(res => {
            const booking = res.data[0].data[0]
            setBookingData(booking)
            // console.log({booking});
            setData({
                ...data,
                _id: booking._id,
                dod: booking.dod,
                doa: booking.doa,
                package: booking.paymentDetails?.package ? booking.paymentDetails.package : '0',
                consultation: booking.paymentDetails?.cvc ? booking.paymentDetails.cvc : '0',
                roomRent: booking.paymentDetails?.roomRent ? booking.paymentDetails.roomRent : '0',
                totalRoomRent: booking.paymentDetails?.totalRoomRent ? booking.paymentDetails?.totalRoomRent : (booking.doa && booking.dod && booking.roomRent) ? (Number((dayjs(booking.dod).diff(booking.doa, 'day')) * booking.roomRent) || 0) : '0',
                otCharges: booking.paymentDetails?.otCharges ? booking.paymentDetails.otCharges : '0',
                surgeonFees: booking.paymentDetails?.soa ? booking.paymentDetails.soa : '0',
                medicineConsumables: booking.paymentDetails?.medicineConsumables ? booking.paymentDetails.medicineConsumables : '0',
                others: booking.paymentDetails?.others ? booking.paymentDetails.others : '0',
                tdsDeductions: booking.paymentDetails?.tdsDeductions ? booking.paymentDetails?.tdsDeductions : 0,
                investigation: booking.paymentDetails?.investigation ? booking.paymentDetails?.investigation : 0,
                anesthetist: booking.paymentDetails?.anesthetist ? booking.paymentDetails?.anesthetist : 0,
                totalBill: (booking.paymentDetails.package ? Number(booking.paymentDetails.package) : 0) + (booking.paymentDetails.cvc ? Number(booking.paymentDetails.cvc) : 0)
                + ((booking.doa && booking.dod && booking.paymentDetails?.roomRent) ? (Number((dayjs(booking.dod).diff(booking.doa, 'day')) * booking.paymentDetails?.roomRent) || 0) : booking.paymentDetails.totalRoomRent ? Number(booking.paymentDetails.totalRoomRent) : 0) + (booking.paymentDetails.investigation ? Number(booking.paymentDetails.investigation) : 0)
                + (booking.paymentDetails.medicineConsumables ? Number(booking.paymentDetails.medicineConsumables) : 0) + (booking.paymentDetails.others ? Number(booking.paymentDetails.others) : 0)
                + (booking.treatment === "Surgical Management" ?  (booking.paymentDetails.anesthetist ? Number(booking.paymentDetails.anesthetist) : 0) + (booking.paymentDetails.otCharges ? Number(booking.paymentDetails.otCharges) : 0) + (booking.paymentDetails.soa ? Number(booking.paymentDetails.soa) : 0) : 0),

                discount: booking.paymentDetails.discount ? booking.paymentDetails.discount : '0',
                finalBill: (booking.paymentDetails.package ? Number(booking.paymentDetails.package) : 0) + (booking.paymentDetails.cvc ? Number(booking.paymentDetails.cvc) : 0)
                + ((booking.doa && booking.dod && booking.paymentDetails?.roomRent) ? (Number((dayjs(booking.dod).diff(booking.doa, 'day')) * booking.paymentDetails?.roomRent) || 0) : booking.paymentDetails.totalRoomRent ? Number(booking.paymentDetails.totalRoomRent) : 0)
                + (booking.paymentDetails.medicineConsumables ? Number(booking.paymentDetails.medicineConsumables) : 0)  + (booking.paymentDetails.investigation ? Number(booking.paymentDetails.investigation) : 0)
                + (booking.paymentDetails.others ? Number(booking.paymentDetails.others) : 0) - ((booking.paymentDetails.discount ? Number(booking.paymentDetails.discount) : 0) + (booking.paymentDetails.tdsDeductions ? Number(booking.paymentDetails.tdsDeductions) : 0)) 
                + (booking.treatment === "Surgical Management" ?  (booking.paymentDetails.anesthetist ? Number(booking.paymentDetails.anesthetist) : 0) + (booking.paymentDetails.otCharges ? Number(booking.paymentDetails.otCharges) : 0) + (booking.paymentDetails.soa ? Number(booking.paymentDetails.soa) : 0) : 0),

                finalBillStatus: booking.paymentDetails.finalBillStatus,
                dischargeDoc: booking.dischargeDoc,
                enhancements: booking.enhancements,
            })
            // console.log(((booking.doa && booking.dod && booking.paymentDetails?.roomRent) ? (Number((dayjs(booking.dod).diff(booking.doa, 'day')) * booking.paymentDetails?.roomRent) || 0): -1));
            setCalculate(prev => !prev)
        })
        .catch(err => {
            console.error(err)
        })
    }, [bookingId])

    useEffect(() => {
        if(props.updateBookingRet) {
            setDisableSave(true)
            // console.warn(props.updateBookingRet);
            if(props.updateBookingRet.success) {
                let booking = props.updateBookingRet.data
                setDisableSave(false)
                // console.warn("update booking: ", booking)
                // openNotificationWithIcon('success','Success','Booking updated successfully')
                handleBack()
            } else {
                setDisableSave(false)
                openNotificationWithIcon('error','Update Failed',"Couldn't update the data" )
            }
        }
    }, [props.updateBookingRet])

    useEffect(() => {
        if(bookingData?.doa && data?.dod && data?.roomRent) {
            const newRoomRent = (Number((dayjs(data.dod).diff(data.doa, 'day')) * data.roomRent) || 0)
            // console.log({newRoomRent});
            setData({...data, totalRoomRent: newRoomRent})
        } else {
            setData({...data, totalRoomRent: bookingData?.paymentDetails?.totalRoomRent})
        }
        setCheck(prev => !prev)
    }, [data.dod, data.roomRent, calculate])

    useEffect(() => {
        // console.log("Data>>>", data);
    }, [data])

    useEffect(()=> {
        if(bookingData?.treatment === "Surgical Management") {
            setData({
                ...data,
                totalBill: (Number(data.package) || 0) + (Number(data.consultation) || 0) + (Number(data.totalRoomRent) || 0) + (Number(data.otCharges) || 0) + (Number(data.surgeonFees) || 0) + (Number(data.medicineConsumables) || 0) + (Number(data.others) || 0) + (Number(data.anesthetist) || 0) + (Number(data.investigation) || 0),
                finalBill: ((Number(data.package) || 0) + (Number(data.consultation) || 0) + (Number(data.totalRoomRent) || 0) + (Number(data.otCharges) || 0) + (Number(data.surgeonFees) || 0) + (Number(data.medicineConsumables) || 0) + (Number(data.others) || 0) + (Number(data.anesthetist) || 0) + (Number(data.investigation) || 0)) - ((Number(data.discount) || 0) + (Number(data.tdsDeductions) || 0)),
            })
        }
        else {
            setData({
                ...data,
                totalBill: (Number(data.package) || 0) + (Number(data.consultation) || 0) + (Number(data.totalRoomRent) || 0) + (Number(data.medicineConsumables) || 0) + (Number(data.others) || 0) + (Number(data.investigation) || 0),
                finalBill: ((Number(data.package) || 0) + (Number(data.consultation) || 0) + (Number(data.totalRoomRent) || 0) + (Number(data.medicineConsumables) || 0) + (Number(data.others) || 0) + (Number(data.investigation) || 0)) - ((Number(data.discount) || 0) + (Number(data.tdsDeductions) || 0)),
            })
        }
    },[check, data.package, data.consultation, data.totalRoomRent, data.otCharges, data.surgeonFees, data.medicineConsumables, data.others, data.discount, data.investigation])

    const handleBack = () => {
        history.push(`/dashboard/booking/booking-details?id=${bookingId}`, {activeTab: '4'})
    }

    const handleChange = (e, field) => {
        setData({
            ...data,
            [field]: e.target.value
        });
    };

    const handleChangeDate = (date, dateString) => {
        if (dateString) {
            setData({
                ...data,
                dod: dateString
            });
        }
    };

    const enhancementDocProps = {
        name: 'file',
        action: `${get_v10_url()}/professional/uploadBookingDoc`,
        accept: 'application/pdf',
        headers : {
            authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
        },
        beforeUpload: (file) => {
            const isPdf = file.type === 'application/pdf'
            const isLess5M = (file.size / 1024 / 1024) < 5
            if (!isPdf) {
                openNotificationWithIcon('error','Upload Failed', 'Please upload PDF files only')
            }
            if (!isLess5M) {
                openNotificationWithIcon('error','Upload Failed', 'Please upload files with size less than 5 MB')
            }
            return (isPdf && isLess5M) || Upload.LIST_IGNORE;
        },
        onChange(info) {
            if(info.file.status !== 'uploading') {
                // console.log(info.file, info.fileList);
            }
            if(info.file.status === 'done') {
                let allDocs = [...documents]
                const docUrl = info.file.response?.data?.docURL
                allDocs.push(docUrl)
                setDocuments(allDocs)
                setEnhanceMentDoc("Enhancement")
                openNotificationWithIcon("success","Upload Successful","Enhancement Letter uploaded successfully")
            } else if (info.file.status === 'error') {
                openNotificationWithIcon("error","Upload Failed","Enhancement Letter uploaded failed")
            }
        },
        onRemove(info) {
            const docUrl = info?.response?.data?.docURL
            let newDocs = [...documents].filter(doc => doc !== docUrl)
            setDocuments(newDocs)
            if(documents.length === 0) {
                setEnhanceMentDoc('')
            }
        },
    }

    const dischargeProps = {
        name: 'file',
        action: `${get_v10_url()}/professional/uploadBookingDoc`,
        accept: 'application/pdf',
        headers : {
            authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
        },
        beforeUpload: (file) => {
            const isPdf = file.type === 'application/pdf'
            const isLess5M = (file.size / 1024 / 1024) < 5
            if (!isPdf) {
                openNotificationWithIcon('error','Upload Failed', 'Please upload PDF files only')
            }
            if (!isLess5M) {
                openNotificationWithIcon('error','Upload Failed', 'Please upload files with size less than 5 MB')
            }
            return (isPdf && isLess5M) || Upload.LIST_IGNORE;
        },
        onChange(info) {
            if(info.file.status !== 'uploading') {
                // console.log(info.file, info.fileList);
            }
            if(info.file.status === 'done') {
                let allDocs = [...documents]
                const docUrl = info.file.response?.data?.docURL
                allDocs.push(docUrl)
                setDocuments(allDocs)
                // setData({...data, dischargeDoc: resBooking.dischargeDoc, documetId: resBooking.documentId})
                setDichargeDoc("Discharge")
                openNotificationWithIcon("success","Upload Successful","Discharge document uploaded successfully")
            } else if (info.file.status === 'error') {
                openNotificationWithIcon("error","Upload Failed","Discharge document Letter uploaded failed")
            }
        },
        onRemove(info) {
            const docUrl = info?.response?.data?.docURL
            let newDocs = [...documents].filter(doc => doc !== docUrl)
            setDocuments(newDocs)
            if(documents.length === 0) {
                setDichargeDoc('')
            }
        },
    }

    const handleSave = () => {
        if(data.package < 0 && data.package !== '') {
            openNotificationWithIcon("error","Error","Package cannot be negative")
            return
        }
        if(data.consultation < 0 || data.consultation === '' || data.consultation == 0) {
            openNotificationWithIcon("error","Error","Consultation cannot be empty, 0 or negative")
            return
        }
        if(data.roomRent < 0 || data.roomRent === '' || data.roomRent == 0) {
            openNotificationWithIcon("error","Error","Room rent/day cannot be empty, 0 or negative")
            return
        }
        if(bookingData?.treatment === "Surgical Management") {
            if(data.otCharges < 0 || data.otCharges === '' || data.otCharges == 0) {
                openNotificationWithIcon("error","Error","OT charges cannot be empty, 0 or negative")
                return
            }
            if(data.surgeonFees < 0 || data.surgeonFees === '' || data.surgeonFees == 0) {
                openNotificationWithIcon("error","Error","Surgeon fee cannot be empty, 0 or negative")
                return
            }
            if(data.anesthetist < 0 || data.anesthetist === '' || data.anesthetist == 0) {
                openNotificationWithIcon("error","Error","Anaesthetist cannot be empty, 0 or negative")
                return
            }
        }
        if(data.medicineConsumables < 0 || data.medicineConsumables === '' || data.medicineConsumables == 0) {
            openNotificationWithIcon("error","Error","Medicine and consumables cannot be empty, 0 or negative")
            return
        }
        if(data.others < 0 && data.others !== '') {
            openNotificationWithIcon("error","Error","Other charges cannot be negative")
            return
        }
        if(data.discount < 0 && data.discount !== '') {
            openNotificationWithIcon("error","Error","Discount cannot negative")
            return
        }
        if(data.investigation < 0 && data.investigation !== '') {
            openNotificationWithIcon("error","Error","Investigation cannot negative")
            return
        }
        if(data.doa!=='' && dayjs(data.dod).isBefore(data.doa)) {
            notification.error({
                message: 'Error',
                description: <><p style={{marginBottom:'5px'}}>Date of discharge cannot be before date of date of admission.</p><p style={{margin:'0'}}>Date of admission: <span style={{fontWeight:'bolder'}}>{data.doa}</span></p></>
            })
            return
        }
        if(isYes === true) {
            if(dischargeDoc === '') {
                openNotificationWithIcon("error","Error","Please uplaod discharge document")
                return
            }
        }
        if(isYes === false) {
            if(enhancementDoc === '') {
                openNotificationWithIcon("error","Error","Please uplaod enhancement letter")
                return
            }
        }
        props.updateBooking({
            bookingId: data._id,
            billFlag: false,
            enhancement: true,
            dod: data.dod,
            package: data.package,
            cvc: data.consultation,
            roomRent: data.roomRent,
            otCharges: data.otCharges,
            soa: data.surgeonFees,
            anesthetist: data.anesthetist,
            medicineConsumables: data.medicineConsumables,
            others: data.others,
            totalBill: data.totalBill,
            discount: data.discount,
            tdsDeductions: data.tdsDeductions,
            totalRoomRent: data.totalRoomRent,
            investigation: data.investigation,
            // finalBill: data.finalBill,
            finalBillStatus: isYes ? 'YES' : 'NO',
            updateMsg: isYes ? 'Final%20Bill' : 'Enhancement',
            preAuth: dischargeDoc!=="" || enhancementDoc!=="" ? "TRUE" : "",
            preAuthStatus: dischargeDoc!=="" ? "DISCHARGE UNDER REVIEW" : enhancementDoc!=="" ? "ENHANCEMENT RECEIVED" : undefined,
            documents: documents,
        })
        setDisableSave(true)
    }

    return (
        <>
        {disableSave && <GlobalLoader/>}
        <div className="final-bill-container">        
            <Card 
                className='final-bill-card-container' 
                style={{ width: '100%', height: '100%' }}
                headStyle={{ marginLeft: '180px', height: '64px', width: 'calc(100vw - 200px)', zIndex: '300', position: 'relative' }}
                title={isYes ? <><ArrowLeftOutlined onClick={handleBack} style={{color:'#30C118', cursor:'pointer'}}/><span style={{color:'#30C118'}}> (Yes)</span> Final Bill Closure</> : <><ArrowLeftOutlined onClick={handleBack} style={{color:'#F93C23', cursor:'pointer'}}/><span style={{color:'#F93C23'}}> No</span> (Need to Enhance the Bill)</>}
            >
                <Row gutter={24}>
                    <Col span={8}>
                        <p>Date of Admission</p>
                        <DatePicker className="bill-input" value={data.doa ? dayjs(data.doa, dateFormat) : null} format={dateFormat} disabled={true}/>
                    </Col>
                    <Col span={8}>
                        <p>Date of Discharge</p>
                        <DatePicker className="bill-input" placeholder="Select Date" value={data.dod ? dayjs(data.dod, dateFormat) : null} format={dateFormat} onChange={handleChangeDate}/>
                    </Col>
                    {isYes ? (
                        <Col span={8}>
                            <p>Upload All Discharge Documents and Final Bill*</p>
                            <Upload {...dischargeProps} placeholder='Upload Document' style={{width:'100%'}}>
                                <Button icon={<UploadOutlined/>} className="upload-btn bill-input">
                                    Upload Document(s)
                                </Button>
                            </Upload>
                        </Col>
                    ) : (
                        <Col span={8}>
                            <p>Upload All Enhancement Letters*</p>
                            <Upload {...enhancementDocProps} placeholder='Upload Document' style={{width:'100%'}}>
                                <Button icon={<UploadOutlined/>} className="upload-btn bill-input">
                                    Upload Document(s)
                                </Button>
                            </Upload>
                        </Col>
                    )}
                </Row>
                <Row gutter={24}>
                    <Col span={8}>
                        <p>Type of Treatment</p>
                        <Input value={bookingData?.treatment} disabled={true} className="bill-input" />
                    </Col>
                </Row>
                <h2>Add Expense List</h2>
                <Row gutter={24}>
                    <Col span={8}>
                        <p>Package</p>
                        <Input className="bill-input" type="number" value={data.package} onChange={e=>handleChange(e,'package')} placeholder={data.package}/>
                    </Col>
                    <Col span={8}>
                        <p>Consultation*</p>
                        <Input className="bill-input" type="number" value={data.consultation} onChange={e=>handleChange(e,'consultation')} placeholder={data.consultation}/>
                    </Col>
                    <Col span={8}>
                        <p>Room Rent/Day*</p>
                        <Input className="bill-input" type="number" value={data.roomRent} onChange={e=>handleChange(e,'roomRent')} placeholder={data.roomRent}/>
                    </Col>
                </Row>
                {bookingData?.treatment === "Surgical Management" && (
                <>
                <Row gutter={24}>
                    <Col span={8}>
                        <p>OT Charges*</p>
                        <Input className="bill-input" type="number" value={data.otCharges} onChange={e=>handleChange(e,'otCharges')} placeholder={data.otCharges}/>
                    </Col>
                    <Col span={8}>
                        <p>Surgeon*</p>
                        <Input className="bill-input" type="number" value={data.surgeonFees} onChange={e=>handleChange(e,'surgeonFees')} placeholder={data.surgeonFees}/>
                    </Col>
                    <Col span={8}>
                        <p>Anaesthetist*</p>
                        <Input className="bill-input" type="number" value={data.anesthetist} onChange={e=>handleChange(e,'anesthetist')} placeholder={data.anesthetist}/>
                    </Col>
                </Row>
                </>
                )}
                <Row gutter={24}>
                    <Col span={8}>
                        <p>Medicine & Consumables*</p>
                        <Input className="bill-input" type="number" value={data.medicineConsumables} onChange={e=>handleChange(e,'medicineConsumables')} placeholder={data.medicineConsumables}/>
                    </Col>
                    <Col span={8}>
                        <p>Others Hospital Expenses</p>
                        <Input className="bill-input" type="number" value={data.others} onChange={e=>handleChange(e,'others')} placeholder={data.others}/>
                    </Col>
                    <Col span={8}>
                        <p>Investigation</p>
                        <Input className="bill-input" type="number" value={data.investigation} onChange={e=>handleChange(e,'investigation')} placeholder={data.investigation}/>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={8}>
                        <p>TDS Deductions</p>
                        <Input className="bill-input" type="number" value={data.tdsDeductions} disabled={true}/>
                    </Col>
                    <Col span={8}>
                        <p>Total Room Rent</p>
                        <Input className="bill-input" type="number" value={data.totalRoomRent} onChange={e=>handleChange(e,'totalRoomRent')} disabled={true}/>
                    </Col>
                </Row>
                <h2></h2>
                <Row gutter={24}>
                    <Col span={8}>
                        <p>Total Amount</p>
                        <Input className="bill-input" type="number" disabled={true} value={data.totalBill} onChange={e=>handleChange(e,'totalBill')} placeholder={data.totalBill}/>
                    </Col>
                    <Col span={8}>
                        <p>Discount</p>
                        <Input className="bill-input" type="number" value={data.discount} onChange={e=>handleChange(e,'discount')} placeholder={data.discount}/>
                    </Col>
                    <Col span={8}>
                        <p>Final Bill</p>
                        <Input className="bill-input" type="number" disabled={true} value={data.finalBill} onChange={e=>handleChange(e,'finalBill')} placeholder={data.finalBill}/>
                    </Col>
                </Row>
                <div className="btn-container">
                    <Button className="save-btn" disabled={disableSave} onClick={handleSave}>Save</Button>
                </div>
            </Card>
        </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    updateBookingLoadingFlag: state.bookingStore.updateBookingLoading,
    updateBookingRet: state.bookingStore.updateBookingRet,
});

export default connect(mapStateToProps, {
    updateBooking,
    updateBookingLoading
})(FinalBill)